import { Outlet } from 'react-router'
import { Sidebar } from './Sidebar'

export function MainLayout () {
  return (
    <div className="flex h-screen w-screen overflow-hidden bg-gray-900">
      <Sidebar />

      <div className="flex-1 flex flex-col overflow-scroll">

        {/* Main Content */}
        <main className="flex-1 p-4 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
